export default "__VITE_ASSET__DT$3izig__"